import { A as API_CLIENT_ID, a as SECRET, S as SERVICE_ID, K as KEY } from "../../../../../chunks/private.js";
import { error, json } from "@sveltejs/kit";
import { p as prisma } from "../../../../../chunks/prisma.js";
import { createHmac } from "node:crypto";
const POST = async ({ locals: { user }, request, url: { origin } }) => {
  if (!user) return error(401, "Unauthorized: No user logged in");
  try {
    const { planId, planPrice, planName } = await request.json();
    if (!planId || !planPrice || !planName) {
      return error(400, "Missing required subscription details");
    }
    const plan = await prisma.subscriptionPlan.findUnique({
      where: { id: planId }
    });
    if (!plan) {
      return error(404, "Subscription plan not found");
    }
    const existingSubscription = await prisma.userSubscription.findFirst({
      where: {
        userId: user.id,
        status: "ACTIVE",
        isActive: true,
        endsAt: {
          gte: /* @__PURE__ */ new Date()
        }
      }
    });
    if (existingSubscription) {
      return error(400, "You already have an active subscription");
    }
    const userDetails = await prisma.user.findUnique({
      where: { id: user.id },
      select: {
        name: true,
        email: true,
        phoneNumber: true,
        idNumber: true
      }
    });
    if (!userDetails) {
      return error(404, "User not found");
    }
    const billRefNumber = `SUB-${Date.now()}-${user.id}-${planId}`;
    if (!API_CLIENT_ID || !SECRET || !SERVICE_ID || !KEY) ;
    const convenienceFee = 0;
    const totalAmount = Number(plan.price) + convenienceFee;
    const paymentDetails = {
      apiClientID: API_CLIENT_ID,
      amountExpected: totalAmount,
      serviceID: SERVICE_ID,
      clientIDNumber: userDetails.idNumber || "0",
      currency: "KES",
      billRefNumber,
      billDesc: `Subscription: ${planName}`,
      clientName: userDetails.name || userDetails.email,
      secret: SECRET
    };
    const dataString = [
      paymentDetails.apiClientID,
      paymentDetails.amountExpected,
      paymentDetails.serviceID,
      paymentDetails.clientIDNumber,
      paymentDetails.currency,
      paymentDetails.billRefNumber,
      paymentDetails.billDesc,
      paymentDetails.clientName,
      paymentDetails.secret
    ].join("");
    const secureHash = generateSecureHash(dataString, KEY);
    return json({
      paymentDetails: {
        ...paymentDetails,
        secureHash,
        callBackURLOnSuccess: `https://demo2.bsl.co.ke/legislation`,
        callBackURLOnFail: `https://demo2.bsl.co.ke/legislation`,
        notificationURL: `https://demo2.bsl.co.ke/api/subscription/notification`,
        clientEmail: userDetails.email,
        clientMSISDN: userDetails.phoneNumber || "0700000000",
        pictureURL: `https://demo2.bsl.co.ke/kLawLogo.png`
      },
      convenienceFee,
      planDetails: {
        id: plan.id,
        name: plan.name,
        price: plan.price,
        duration: plan.duration
      }
    });
  } catch (err) {
    console.error("Subscription payment initiation error:", err);
    return error(500, "Failed to initiate subscription payment");
  }
};
function generateSecureHash(dataString, secretKey) {
  const hmac = createHmac("sha256", secretKey);
  hmac.update(dataString);
  return hmac.digest("base64");
}
export {
  POST
};
